export default __webpack_public_path__ + "static/meta_share-85aa32f276b52f7bbe6d9224c966e682.jpg";